var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showRow ? _c('div', {
    staticClass: "table-filters-bar"
  }, [_c('div', {
    staticClass: "table-filters-bar__pills d-flex flex-wrap align-center"
  }, [_vm.activeViewLabel ? _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "300"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "table-filter-pill table-filter-pill--view",
          attrs: {
            "type": "button",
            "aria-label": _vm.activeViewLabel
          }
        }, 'button', attrs, false), on), [_c('span', {
          staticClass: "table-filter-pill__label"
        }, [_vm._v(_vm._s(_vm.activeViewLabel))]), _c('span', {
          staticClass: "table-filter-pill__remove",
          attrs: {
            "role": "button",
            "tabindex": "0",
            "aria-label": _vm.$translate('removeView')
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.$emit('clear-view');
            },
            "keyup": function keyup($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              $event.stopPropagation();
              return _vm.$emit('clear-view');
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("mdi-close")])], 1)])];
      }
    }], null, false, 1879593492)
  }, [_c('span', [_vm._v(_vm._s(_vm.$translate("savedView")))])]) : _vm._e(), _vm._l(_vm.selectedProducts, function (product) {
    return _c('v-tooltip', {
      key: 'product-' + product.id,
      attrs: {
        "bottom": "",
        "open-delay": "300"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c('button', _vm._g(_vm._b({
            staticClass: "table-filter-pill table-filter-pill--active",
            attrs: {
              "type": "button",
              "aria-label": _vm.productFilterLabel(product)
            }
          }, 'button', attrs, false), on), [_c('span', {
            staticClass: "table-filter-pill__label"
          }, [_vm._v(_vm._s(_vm.productFilterLabel(product)))]), _c('span', {
            staticClass: "table-filter-pill__remove",
            attrs: {
              "role": "button",
              "tabindex": "0",
              "aria-label": _vm.removeProductLabel
            },
            on: {
              "click": function click($event) {
                $event.stopPropagation();
                return _vm.$emit('remove-product', product.id);
              },
              "keyup": function keyup($event) {
                if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
                $event.stopPropagation();
                return _vm.$emit('remove-product', product.id);
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "x-small": ""
            }
          }, [_vm._v("mdi-close")])], 1)])];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(_vm.$translate("productFilter")))])]);
  }), _vm._l(_vm.leadingActiveFilterConfigs, function (conf) {
    return _c('TableFilterPill', {
      key: 'active-' + conf.field,
      attrs: {
        "filter": conf,
        "filters": _vm.filters,
        "choices": _vm.choicesFor(conf),
        "remove-label": _vm.$translate('removeFilter')
      },
      on: {
        "change": function change($event) {
          return _vm.onPillChange(conf, $event);
        }
      }
    });
  }), _vm.panelOpen ? [_vm._l(_vm.inactiveQuickConfigs, function (conf) {
    return _c('TableFilterPill', {
      key: 'quick-' + conf.field,
      attrs: {
        "filter": conf,
        "filters": _vm.filters,
        "choices": _vm.choicesFor(conf),
        "remove-label": _vm.$translate('removeFilter')
      },
      on: {
        "change": function change($event) {
          return _vm.onPillChange(conf, $event);
        }
      }
    });
  }), _vm._l(_vm.extraAddedFilterConfigs, function (conf) {
    return _c('TableFilterPill', {
      key: 'added-' + conf.field,
      attrs: {
        "filter": conf,
        "filters": _vm.filters,
        "choices": _vm.choicesFor(conf),
        "default-open": _vm.isPendingAddFilter(conf),
        "remove-label": _vm.$translate('removeFilter')
      },
      on: {
        "change": function change($event) {
          return _vm.onAddedPillChange(conf, $event);
        },
        "menu-close": function menuClose($event) {
          return _vm.onAddedPillMenuClose(conf);
        }
      }
    });
  })] : _vm._e(), _vm.showAddFilterControls ? _c('div', {
    staticClass: "table-filters-bar__actions d-flex align-center"
  }, [_vm.addableFilters.length ? _c('v-menu', {
    attrs: {
      "offset-y": "",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "table-filter-pill table-filter-pill--add",
          attrs: {
            "type": "button",
            "aria-label": _vm.$translate('addFilter')
          }
        }, 'button', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$translate("addFilter")) + " ")], 1)];
      }
    }], null, false, 331453553),
    model: {
      value: _vm.addMenuOpen,
      callback: function callback($$v) {
        _vm.addMenuOpen = $$v;
      },
      expression: "addMenuOpen"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.addableFilters, function (conf) {
    return _c('v-list-item', {
      key: 'add-' + conf.field,
      on: {
        "click": function click($event) {
          return _vm.openAddedFilter(conf);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(conf.label))])], 1);
  }), 1)], 1) : _vm._e(), _vm.canReset ? _c('span', {
    staticClass: "table-filters-bar__reset link",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": _vm.onReset,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.onReset.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("resetFilters")) + " ")]) : _vm._e()], 1) : _vm._e()], 2)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }